<ng-template #contentOffres let-modal class="modal-share p-3">
  <div class="modal-header container border-0 pt-3">

    <button type="button" class="btn-close btn-close-black me-1" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body  p-0">

    <div class="p-3 text-center">
      <h4>LISTE DE MES OFFRES D’ACHAT
      </h4>
    </div>

    <div class="bar-bloc text-white">
      <div class="product-desc agenda-page main-bg p-3">
        <div class="title-description white-title">
          <div class="inner">
            <div class="title-description text-uppercase">

              <h3 class="white">{{bien.niveau.code_text}} <span *ngIf="bien.property.size_generique">de
                {{bien.property.size_generique}} m²</span> à<br>
                <span class="accent">{{bien.ville}}</span>
              </h3>
            </div>
            <p class="clearfix big-title">
              <span style="float:right" class="float-right price-title">
                {{bien?.property.price_formatted}}&nbsp;€
              </span>
            </p>

            <p class="location-title italic-title"
               *ngIf="bien?.property?.adresseBien && !bien?.property.adresseBien.codePostalF">
              {{bien?.property.location ? bien?.property.location : bien?.location}}</p>

            <div class="details clearfix">
              <span class="badge-list-item outlined">
                  Ref : {{bien.property.reference}}
              </span>
              <svg width="48" height="48" viewBox="0 0 15 15" fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M5.40446 3.85168H3.08008V6.17606" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.18199 11.9871H11.2158V9.95323" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.11391 11.9871H3.08008V9.95323" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.98555 9.37213L3.08008 11.9871" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.18199 3.85168H11.2158V5.88552" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.31035 6.46661L11.2158 3.85169" stroke="#ffffff" stroke-width="0.8"
                      stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span> {{bien.property.size_generique}} m²</span>

              <span *ngIf="bien.property.pieces"> <svg width="48" height="48" viewBox="0 0 15 15"
                                                       fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.01309 6.46665V4.14227H1.20215V12.2776H12.2429V4.14227H9.62802"
                                          stroke="#ffffff" stroke-width="0.8" stroke-linecap="round"
                                          stroke-linejoin="round"/>
                                    <path d="M4.68848 12.2776L4.68848 7.91937" stroke="#ffffff" stroke-width="0.8"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M12.2429 8.2099H8.46582" stroke="#ffffff" stroke-width="0.8"
                                          stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                {{bien?.property.pieces ? bien?.property.pieces : bien?.pieces}} Pièce(s)
              </span>
              <span *ngIf="(bien?.property.room ? bien?.property.room : bien?.room)">
                                <svg width="48" height="48" viewBox="0 0 25 25" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M19.1635 18.388L17.8085 16.2649H4.63487L3.40301 18.3373C3.29432 18.5185 3.01172 18.446 3.01172 18.2286V10.9679C3.01172 10.7651 3.17838 10.5984 3.38127 10.5984H19.178C19.3809 10.5984 19.5475 10.7651 19.5475 10.9679V18.2793C19.5475 18.4895 19.2722 18.5692 19.1635 18.3953V18.388Z"
                                      stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10"/>
                                    <path
                                      d="M3.91016 10.5984V5.46811L4.06957 5.42463C8.80134 4.24351 13.7505 4.25075 18.475 5.44637L18.562 5.46811V10.5984"
                                      stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10"/>
                                    <path
                                      d="M12.5186 10.5984V9.69263C12.5186 8.48976 13.4968 8.10571 14.6997 8.10571C15.9025 8.10571 16.8808 8.48976 16.8808 9.69263V10.5984"
                                      stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10"/>
                                    <path
                                      d="M5.52539 10.5984V9.69263C5.52539 8.48976 6.49638 8.10571 7.69925 8.10571C8.90212 8.10571 9.88035 8.48976 9.88035 9.69263V10.5984"
                                      stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10"/>
                                </svg>
                {{bien?.property.room ? bien?.property.room : bien?.room}}
                Chambre{{(bien?.property.room ? bien?.property.room : bien?.room) > 1 ? 's' : ''}}
              </span>
            </div>
          </div>
        </div>
        <!-- formulaire liste -->
        <div class="listeoffres-bloc">
          <div class="content mesInfos-content list-wrapper">
            <!-- Si propriétaire du bien -->
            <p class="text-visites" *ngIf="userConnected?.id == bien?.ownerid">Vous retrouverez dans la
              liste ci-dessous toutes les offres d’achat réalisées par des acquéreurs intéressés par votre
              bien. Elles ont toutes été préalablement validées par votre Conseiller. Pour les valider, il a
              contrôlé le financement et la capacité d’emprunt de chacun des acquéreurs. Pour information,
              une fois la durée de validité passée, l’offre d’achat n’est plus valable. Votre Conseiller se
              tient bien entendu à votre disposition pour toute question.</p>
            <!-- Si client qui a fait l'offre du bien -->
            <p class="text-visites" *ngIf="userConnected?.id != bien?.ownerid">Vous retrouverez dans la
              liste ci-dessous les offres d'achat qui ont été transmises au(x) client(s) vendeur(s).</p>
          </div>
        </div>
        <!-- /formulaire liste -->
      </div>
    </div>

    <div class="data-bloc-offres p-4">
      <div class="row">
        <!-- Rotating card -->
        <div *ngFor="let offre of OfferData; let i = index;" class="col-12 col-md-4 card border-0 flip-card ">
          <div class="flip-card-inner">
            <div class="flip-card-front p-3">
              <div *ngIf="!offre.NomAcqByPart">
                <span class="semibold-sm">Nom : </span>{{offre.name}}
              </div>
              <div *ngIf="offre.NomAcqByPart">
                <span class="semibold-sm">Nom : </span>{{offre?.PrenomAcqByPart}} {{offre?.NomAcqByPart}}
              </div>
              <div><span class="semibold-sm">Proposition : </span> {{offre?.prixPropose}}&nbsp;€</div>
              <div><span class="semibold-sm">Date de dépôt : </span> {{offre?.date|date:'dd/MM/yyyy' }}</div>
              <div><span
                class="semibold-sm">Durée de Validité : </span> {{offre?.validite}} {{offre?.validite > 1 ? 'jours' : 'jour'}}
              </div>
              <div>
                <span *ngIf="offre.response == 1">Offre acceptée</span>
                <span *ngIf="offre.response == 2">Offre refusée</span><!--&& offre.isValide-->
                <span
                  *ngIf="!offre.response && !offre.NomAcqByPart && offre.isValide && offre?.etatcat?.id < 5 || offre?.etatcat?.id == 10">En préparation ou Abandonnée</span>
                <span *ngIf="!offre.response && !offre.NomAcqByPart && !offre.isValide && offre?.etatcat?.id < 5">Aucune réponse enregistrée</span>
                <span *ngIf="!offre.response && !offre.NomAcqByPart && offre?.etatcat?.id == 5 && offre.simplified">Offre enregistree</span>
                <span
                  *ngIf="!offre.response && offre.NomAcqByPart && offre?.etatcat?.id < 5 || offre?.etatcat?.id == 10">Offre partenaire</span>
                <span
                  *ngIf="!offre.response && ((offre?.etatcat?.id == 6 || offre?.etatcat?.id == 7) && offre.isValide)">Signature oodrive en cours</span>
                <span
                  *ngIf="!offre.response && ((offre?.etatcat?.id == 6 || offre?.etatcat?.id == 7) && !offre.isValide)">Aucune réponse enregistrée</span>
                <span *ngIf="!offre.response && offre?.etatcat?.id == 9">Signature abandonnée</span>
              </div>
            </div>
            <div class="flip-card-back p-3">
              <div class="clearfix">
                <!--                                <p *ngIf="offre.address?.rue || offre.address?.cp" class="name">-->
                <!--                                    {{offre.address?.rue}} <br />{{offre.address?.cp}}</p>-->
                <p class="price-wrapper hidden-lg hidden-ms clearfix"
                   *ngIf="(userConnected?.type.id != 5 || offre.souhait != true) &&
                                        !offre.apport && !offre.credits && !offre.nets && !offre.comment">
                                      <span class="wish label">
                                          Aucun commentaire enregistré
                                      </span>
                </p>
                <p class="price-wrapper hidden-lg hidden-ms clearfix"
                   *ngIf="userConnected?.type.id == 5 && offre.souhait == true">
                                    <span class="wish label">
                                        souhaite être présent au passage de l'offre
                                    </span>
                  <!-- <span class="price mx-2">{{offre.souhait ? "Oui" : "Non"}}</span>-->
                </p>
                <p class="price-wrapper clearfix" *ngIf="offre.apport">
                  <span class="label">Montant de l’apport</span>
                  <span class="price mx-2">{{offre.apport}}&nbsp;€</span>
                </p>
                <p class="price-wrapper credit clearfix" *ngIf="offre.credits">
                  <span class="label">Montant des crédits</span>
                  <span class="price mx-2">{{offre.credits}}&nbsp;€</span>
                </p>
                <p class="price-wrapper net " *ngIf="offre.nets">
                  <span class="label">Revenus nets</span>
                  <span class="price mx-2">{{offre.nets}}&nbsp;€</span>
                </p>
              </div>
              <div class="bottom-container clearfix">
                <p class="comment-wrapper credit" *ngIf="offre.comment">
                  <span class="label">Commentaire</span>
                  <span class="comment">{{offre.comment}}</span>
                </p>
              </div>
            </div>
          </div>
          <!-- TODO Cyrille : {{offre.etatcat.id}} {{offre.etatcat.label}}-->
          <div
            *ngIf="!offre.simplified &&!offre.response && offre.userid == userConnected.id && offre.etatcat?.id == 5 && offre.isValide"
            class="row-cols-2">
            <a (click)="responseOffer(1, offre)" class="btn btn-primary rounded-0">Accepter</a>
            <a (click)="responseOffer(2, offre)" class="btn btn-gold rounded-0">Refuser</a>
          </div>
        </div>
        <!-- Rotating card -->
      </div>
      <p *ngIf="!OfferData?.length && isLoadedHttp && bien.ownerid != userConnected?.id"
         class="no-offers text-center">Vous n'avez fait aucune offre.
      </p>
      <p *ngIf="!OfferData?.length && isLoadedHttp && bien.ownerid == userConnected?.id"
         class="no-offers text-center">Vous n'avez reçu aucune offre.
      </p>
    </div>
  </div>
</ng-template>
<div class="btn-bien">
  <a role="button" class="w-100 iconClass" (click)="openVertically(contentOffres)"
     [attr.aria-label]="'Voir les offres du bien (' + nbOffres + ')'">
    <span class="badge badge-secondary text-bleu-tdm" aria-hidden="true">{{nbOffres}}</span>
    <i class="w-100 bi bi-house-up-fill" aria-hidden="true"></i>
  </a>
</div>
<app-modal-alert-bien *ngIf="showAlert" [status]="statusConfirmation"
                      [message]="messageConfirmation"></app-modal-alert-bien>
